import { Navigate } from "react-router-dom";
import { MARKET_TOKEN_KEY } from "@/api/auth";
import Workspace from "@/pages/workspace/page";

export default function ProtectedWorkspace() {
  return localStorage.getItem(MARKET_TOKEN_KEY) ? <Workspace /> : <Navigate to="/login" replace />;
}
